__turbopack_context__.v({
  "background": "footer-module-scss-module__nZzg-q__background",
  "background-container": "footer-module-scss-module__nZzg-q__background-container",
  "container": "footer-module-scss-module__nZzg-q__container",
  "footer": "footer-module-scss-module__nZzg-q__footer",
  "image-container": "footer-module-scss-module__nZzg-q__image-container",
  "middle-img": "footer-module-scss-module__nZzg-q__middle-img",
  "outro": "footer-module-scss-module__nZzg-q__outro",
  "subtitle": "footer-module-scss-module__nZzg-q__subtitle",
  "terms": "footer-module-scss-module__nZzg-q__terms",
  "title": "footer-module-scss-module__nZzg-q__title",
});
